import muiUseMediaQuery from "@material-ui/core/useMediaQuery";

export const useMediaQuery = (query, options) => muiUseMediaQuery(query, options);